//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.2'.
//
package de.katoonerie

import com.apollographql.apollo3.annotations.ApolloAdaptableWith
import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.CompiledField
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.Optional
import com.apollographql.apollo3.api.Query
import com.apollographql.apollo3.api.json.JsonWriter
import com.apollographql.apollo3.api.obj
import de.katoonerie.adapter.AssetQuery_ResponseAdapter
import de.katoonerie.adapter.AssetQuery_VariablesAdapter
import de.katoonerie.selections.AssetQuerySelections
import kotlin.Boolean
import kotlin.String
import kotlin.Unit

public data class AssetQuery(
  public val preview: Optional<Boolean?> = Optional.Absent,
  public val id: String,
) : Query<AssetQuery.Data> {
  public override fun id(): String = OPERATION_ID

  public override fun document(): String = OPERATION_DOCUMENT

  public override fun name(): String = OPERATION_NAME

  public override fun serializeVariables(writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters): Unit {
    AssetQuery_VariablesAdapter.toJson(writer, customScalarAdapters, this)
  }

  public override fun adapter(): Adapter<Data> = AssetQuery_ResponseAdapter.Data.obj()

  public override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = de.katoonerie.type.Query.type
  )
  .selections(selections = AssetQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(AssetQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val asset: Asset?,
  ) : Query.Data

  public data class Asset(
    public val contentType: String?,
    public val title: String?,
    public val url: String?,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "937e908ff72bc83bdfa7fc56f48f7c278467cb13fb641b90c4947ba7605cc60c"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * query Asset($preview: Boolean, $id: String!) {
     *   asset(id: $id, preview: $preview) {
     *     contentType
     *     title
     *     url
     *   }
     * }
     */
    public val OPERATION_DOCUMENT: String
      get() =
          "query Asset(${'$'}preview: Boolean, ${'$'}id: String!) { asset(id: ${'$'}id, preview: ${'$'}preview) { contentType title url } }"

    public const val OPERATION_NAME: String = "Asset"
  }
}
